import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { siteConfig } from '../../data/config';
import { Button } from '../ui/button';
import { Phone, Calendar } from 'lucide-react';

const MobileCTA = () => {
  const { t } = useLanguage();

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 shadow-[0_-4px_12px_rgba(0,0,0,0.1)] z-50 md:hidden"
      data-testid="mobile-cta-bar"
    >
      <div className="flex gap-3 max-w-lg mx-auto">
        <Button
          asChild
          className="flex-1 bg-primary hover:bg-primary/90 text-white font-bold h-12 text-base shadow-md"
          data-testid="mobile-call-btn"
        >
          <a href={siteConfig.phoneTel}>
            <Phone className="w-5 h-5 mr-2" />
            {t('cta.callNow')}
          </a>
        </Button>
        <Button
          asChild
          className="flex-1 bg-accent text-accent-foreground hover:bg-accent/90 font-bold h-12 text-base shadow-md"
          data-testid="mobile-book-btn"
        >
          <a href={siteConfig.bookingUrl} target="_blank" rel="noopener noreferrer">
            <Calendar className="w-5 h-5 mr-2" />
            {t('cta.book')}
          </a>
        </Button>
      </div>
    </div>
  );
};

export default MobileCTA;
